<template>
	<div class="dashboard stock-adjustment">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Stock Adjustment</h1>

		<b-field label="Select Shop (required)">
			<b-autocomplete
				v-model="shopsSuggestions"
				:data="filteredShops"
				:open-on-focus="true"
				placeholder="Shop"
				field="name"
				:disabled="disableShopSelector"
				@select="option => (selectedShop = option)"
				class="shopAutoComplete"
			>
				<template slot="empty">No results found</template>
			</b-autocomplete>
		</b-field>

		<label class="csv-reader" v-if="selectedShop">
			<input type="file" @change="loadTextFromFile" />
		</label>

		<h1 v-if="complete"><br /><br />Update Completed!</h1>

		<div v-if="totalCount > 0 && updatingCount == 0"><br /><br />Checking {{ checkingCount }} of {{ totalCount }}</div>

		<div v-if="updatingCount > 0"><br /><br />Updating {{ updatingCount }} of {{ totalCount }}</div>

		<div v-if="error"><br /><br />There is an error!</div>

		<div v-if="errorMessage.length > 0">
			<div v-for="(data, index) of errorMessage" v-bind:key="index">{{ data }}</div>
		</div>

		<div class="button-container" v-if="checkComplete && !error && !complete">
			<div class="big-button" @click="adjustStock()">
				Adjust Stock Now!
			</div>
		</div>

		<div class="check-results">
			<div v-if="invalidCode.length > 0">
				<h1>INVALID PRODUCTS</h1>
				<div v-for="(code, key) of invalidCode" :key="key">
					<p>{{ code }}</p>
				</div>
			</div>

			<div v-if="validCode.length > 0">
				<h1>VALID PRODUCTS</h1>
				<div v-for="(code, key) of validCode" :key="key">
					<p>{{ code }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'productsCheck',
	data: () => ({
		limit: 50,
		isLoading: false,
		totalCount: 0,
		checkingCount: 0,
		updatingCount: 0,
		checkComplete: false,
		complete: false,
		products: [],
		checkedProducts: [],
		invalidCode: [],
		validCode: [],
		shops: [],
		shopsSuggestions: '',
		selectedShop: null,
		error: false,
		errorMessage: [],
		disableShopSelector: false
	}),

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	mounted: async function() {
		if (this.$store.state.auth) {
			this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
		}

		await this.getShops()
	},

	watch: {},
	methods: {
		adjustStock: async function() {
			this.isLoading = true
			this.updatingCount = 0

			var i
			var skip
			var end
			var totalLoop = Math.ceil(this.totalCount / this.limit)

			for (i = 0; i < totalLoop; i++) {
				skip = i * this.limit
				end = skip + this.limit
				// Loop every row to put it in array

				const parallel = this.checkedProducts.slice(skip, end).map(async product => {
					this.updatingCount++

					let { increase, decrease, description } = product

					let data = {
						id: product.shop_product._id,
						shop: this.selectedShop._id,
						description,
						adjustments: {
							stock: {}
						}
					}

					if (increase) {
						data.adjustments.stock = {
							type: 'increase',
							value: increase
						}
					} else {
						data.adjustments.stock = {
							type: 'decrease',
							value: decrease
						}
					}

					await this.$api.adjustStock({ data })
				})

				await Promise.all(parallel)
			}

			this.checkComplete = true
			this.complete = true
			this.isLoading = false

			this.$swal.fire('Complete!', 'Stock Adjustment Completed!', 'success')
		},

		checkData: async function() {
			this.checkedProducts = []
			this.errorMessage = []
			var i
			var skip
			var end
			var totalLoop = Math.ceil(this.totalCount / this.limit)

			for (i = 0; i < totalLoop; i++) {
				// for (i = 0; i < 3; i++) {

				skip = i * this.limit
				end = skip + this.limit
				// Loop every row to put it in array

				const parallel = this.products.slice(skip, end).map(async product => {
					this.checkingCount++

					let { increase, decrease, description } = product

					let data = {
						shop: this.selectedShop._id,
						refs: {
							product: {
								bd_code: product.bdCode
							}
						}
					}

					var result = await this.getShopProductsLoop(data)

					if (result == undefined || result.data.count == 0) {
						this.error = true

						this.$swal.fire({
							icon: 'info',
							title: 'Oops...',
							text: 'Cannot find ' + product.bdCode + ' in ' + this.selectedShop.name
						})

						this.errorMessage.push('Cannot find ' + product.bdCode + ' in ' + this.selectedShop.name)
					}

					// Get correct BD Code
					let doubleCheckBDCode = ''

					if (result.data.count > 1) {
						for (const bdCodeCheck of result.data.list) {
							if (bdCodeCheck.refs.product.bd_code == product.bdCode) {
								doubleCheckBDCode = bdCodeCheck
							}
						}
					} else {
						doubleCheckBDCode = result.data.list[0]
					}

					let newData = {
						shop_product: doubleCheckBDCode,
						increase,
						decrease,
						description
					}

					this.checkedProducts.push(newData)
				})

				await Promise.all(parallel)
			}

			this.checkComplete = true

			this.isLoading = false
		},

		getShopProductsLoop: async function(data) {
			return await this.$api.shopProduct({ data })
		},

		// Load CSV and add into array
		loadTextFromFile(ev) {
			this.complete = false
			this.products = []
			this.error = false
			this.updatingCount = 0
			this.disableShopSelector = true
			this.totalCount = 0
			this.checkingCount = 0
			this.checkComplete = false
			this.checkedProducts = []
			var error = false
			const file = ev.target.files[0]
			const reader = new FileReader()

			// reader.onload = e => this.$emit("load", e.target.result);
			reader.onload = event => {
				var raw = event.target.result.split(/\r?\n/)

				var header = raw[0].split(/,/)

				let bdCode = header.indexOf('BD_CODE')
				let increase = header.indexOf('INCREASE')
				let decrease = header.indexOf('DECREASE')
				let description = header.indexOf('DESCRIPTION')

				if (bdCode == -1) {
					this.$swal.fire('Cannot find BD_CODE')
					error = true
					this.isLoading = false
					return
				} else if (increase == -1) {
					this.$swal.fire('Cannot find INCREASE')
					error = true
					this.isLoading = false
					return
				} else if (decrease == -1) {
					this.$swal.fire('Cannot find DECREASE')
					error = true
					this.isLoading = false
					return
				} else if (description == -1) {
					this.$swal.fire('Cannot find DESCRIPTION')
					error = true
					this.isLoading = false
					return
				}

				// Remove first row
				raw.shift()

				// Error checking with loop
				raw.map(async data => {
					this.isLoading = true
					var splitData = data.split(/,/)

					// if bdcode is blank, exit now
					if (!splitData[bdCode]) {
						return
					} else {
						this.totalCount++
					}

					// Check to make sure both fields does not have any values
					if (splitData[increase] && splitData[decrease]) {
						this.$swal.fire({
							icon: 'info',
							title: 'Oops...',
							text: 'Cannot have both increase and decrease for ' + splitData[bdCode]
						})
						error = true
						this.error = true
						return
					}

					// Check to make sure both values are not blank
					if (!splitData[increase] && !splitData[decrease]) {
						this.$swal.fire({
							icon: 'info',
							title: 'Oops...',
							text: 'Cannot have BLANK increase and decrease for ' + splitData[bdCode]
						})
						error = true
						this.error = true
						return
					}

					// Check to make sure there is description
					if (!splitData[description]) {
						this.$swal.fire({
							icon: 'info',
							title: 'Oops...',
							text: 'Description is requried for ' + splitData[bdCode]
						})
						error = true
						this.error = true
						return
					}

					let product = {
						bdCode: splitData[bdCode],
						increase: splitData[increase],
						decrease: splitData[decrease],
						description: splitData[description]
					}

					this.products.push(product)
				})

				// Continue if there are no errors
				if (!error) {
					this.checkData()
				}
			}

			reader.readAsText(file)
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
